import React, { useEffect, useRef, useState } from "react";
import styles from "./transactionDetailModal.module.css";
import CopyClipBoard from "../../common/CopyClipboard/CopyClipBoard";

const XoticPartnerDetails = ({ transactionDetails, status, setUtrNo }) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputE1 = useRef();

  useEffect(() => {
    if (inputE1.current) {
      inputE1.current.focus();
    }
  }, [inputE1]);

  return (
    <div className={styles.transactionDetails}>
      <hr className={styles.divider} />

      <div className={styles.modalRow}>
        <p className={` ${styles.modalText} ${styles.textGrey}`}>
          Transaction ID
        </p>
        <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
          <p className={` ${styles.modalText} ${styles.textBlack}`}>
            {transactionDetails
              ? transactionDetails.transactionId
                ? transactionDetails.transactionId.length > 30
                  ? `${transactionDetails.transactionId.substring(0, 25)}...`
                  : transactionDetails.transactionId
                : "--"
              : "--"}{" "}
            <CopyClipBoard value={transactionDetails.transactionId} />
          </p>
        </div>
      </div>
      <div className={styles.modalRow}>
        <p className={` ${styles.modalText} ${styles.textGrey}`}>Name</p>
        <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
          <p className={` ${styles.modalText} ${styles.textBlack}`}>
          Xotik Travel and Forex Pvt. Ltd.{" "}
            <CopyClipBoard value={"Xotik Travel and Forex Pvt. Ltd."} />
          </p>
        </div>
      </div>

      <div className={styles.modalRow}>
        <p className={` ${styles.modalText} ${styles.textGrey}`}>
          Account Number
        </p>
        <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
          <p className={` ${styles.modalText} ${styles.textBlack}`}>
          2402216360387650 <CopyClipBoard value={"2402216360387650"} />
          </p>
        </div>
      </div>

      <div className={styles.modalRow}>
        <p className={` ${styles.modalText} ${styles.textGrey}`}>Ifsc Code</p>
        <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
          <p className={` ${styles.modalText} ${styles.textBlack}`}>
          AUBL0002163 <CopyClipBoard value={"AUBL0002163"} />
          </p>
        </div>
      </div>
      <div className={styles.modalRow}>
        <p className={` ${styles.modalText} ${styles.textGrey}`}>Bank Name</p>
        <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
          <p className={` ${styles.modalText} ${styles.textBlack}`}>
          AU Small Finance Bank <CopyClipBoard value={"AU Small Finance Bank"} />
          </p>
        </div>
      </div>
      {status === "Initiated" && (
        <div className={styles.modalRow}>
          <p className={` ${styles.modalText} ${styles.textGrey}`}>
            Enter UTR Number
          </p>
          <div className={` ${styles.modalRow} ${styles.modalRowInfo}`}>
            <input
              ref={inputE1}
              onChange={(e) => {
                if(e.target.value.length <= 40){
                  setUtrNo(e.target.value)}}
                }
                maxLength={40}
              type="text"
              style={{
                borderLeft: "0px",
                borderTop: "0px",
                borderRight: "0px",
                borderBottom: isFocused ? "1px solid black" : "1px solid black",
                outline: "none",
                textAlign: "right",
              }}
              className={` ${styles.modalText} ${styles.textBlack}`}
              onFocus={() => setIsFocused(true)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default XoticPartnerDetails;
